import { PageHeader } from '@shared/infrastructure/ui/components/header/pageHeader';
import { DashboardLayout } from '@shared/infrastructure/ui/layout/dashboardLayout';

export const Dashboard = () => {
  return (
    <DashboardLayout>
      <>
        <PageHeader>
          <>Dashboard</>
        </PageHeader>
        <p>
          A recent update has been released to Virtual Clinic Content Management
          System (13.02.2024), introducing new functions and fixing several
          issues:
        </p>
        <ul>
          <li>
            Subtopic and content views were added. You can now create, edit and
            delete subtopics and contents.
          </li>
          <li>
            Videos and documents for content-items can now be uploaded. Videos
            are encoded as stream automatically, which takes 15 min on average
            to complete.
          </li>
          <li>
            Fixed a bug causing the country- and language-selection to reset
            every time you navigated or refreshed the page.
          </li>
          <li>
            Fixed hardcoded topics and subtopics, so they can now be edited in
            the Content Management System.
          </li>
          <li>
            Azure Media Service is to be retired on 30. June 2024. Streams and
            videos have been migrated to Bitmovin streaming service.
          </li>
          <li>
            Lots of smaller bugfixes and quality of life improvements in the
            Content Management System and Virtual Clinic.
          </li>
          <li>
            Improved overall performance in Content Management System and
            Virtual Clinic.
          </li>
          <li>
            The snapshot functionality has been introduced to capture and restore country specific data.
          </li>
        </ul>
      </>
    </DashboardLayout>
  );
};
